<template>
  <div>
    <b-form
      inline
      class="mb-2"
    >
      <b-form-input
        v-model="searchTerm"
        :placeholder="$t('message.SearchPlaceholder')"
        type="text"
        class="d-inline mb-1"
      />

    </b-form>

    <!-- table -->
    <vue-good-table
      style-class="vgt-table striped"
      :columns="columns"
      :rows="data"
      :sort-options="{
        enabled: false,
      }"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
    >

      <template
        slot="table-column"
        slot-scope="props"
      >
        <span>
          {{ $t(props.column.label) }}
        </span>
      </template>

    </vue-good-table>

  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormInput, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable,
    BFormInput,
    BForm,
  },
  directives: {
    Ripple,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      data: [],
      columns: [
        {
          label: 'Index',
          field: 'index',
        },
        {
          label: 'Group Name',
          field: 'groupName',
        },
      ],
      pageLength: 10,
      searchTerm: '',
      selectedRecords: [],
    }
  },
  created() {
    this.getProjectScoreGroups()
  },
  methods: {
    getProjectScoreGroups() {
      useJwt.axiosIns.get(`project/projectscoregroups/${this.projectId}`)
        .then(response => {
          if (response.data) {
            this.data = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
